import React, { useEffect, useState } from 'react'

import { useRecoilState } from 'recoil'

import {
  PageHeader, message, Row, Col, Button, Spin, Space, Modal,
} from 'antd'
import { useHistory } from 'react-router-dom'
import {
  LeftOutlined, ExclamationCircleOutlined,
} from '@ant-design/icons'

import {
  totalPriceState, discountPriceState, discountTypeState, netPriceState, roundingState, userState, sumPaymentState,
} from '../../store/atoms'

import { fetch } from '../../utils/fetch'
import OrderHeader from '../order/component/OrderHeader'
import SapSoComponent from '../order/component/SapSo'
import TempSoComponent from '../order/component/TempSo'

import DiscountTotalSoPrice from '../order/component/DiscountTotalSoPrice'

import OrderStatus from '../component/OrderStatus'

import CommentModal from './component/CommentModal'

const { confirm } = Modal

const ReviewDetail = (props) => {
  const history = useHistory()
  const { orderId } = props?.match?.params
  const [isLoading, setIsLoading] = useState(true)
  const [isFixItemCat, setIsFixItemCat] = useState(false)
  const [orderHeaderData, setOrderHeaderData] = useState(null)
  const [soSapList, setSoSapList] = useState([])
  const [haveTemp, setHaveTemp] = useState(false)
  const [commentVisible, setCommentVisible] = useState(false)
  const [title, setTitle] = useState('')
  const [statusOrder, setStatusOrder] = useState('')
  const [, setTotalPrice] = useRecoilState(totalPriceState)
  const [, setDiscountPrice] = useRecoilState(discountPriceState)
  const [, setDiscountType] = useRecoilState(discountTypeState)
  const [netPrice, setNetPrice] = useRecoilState(netPriceState)
  const [, setRounding] = useRecoilState(roundingState)
  const [sumPayment] = useRecoilState(sumPaymentState)
  const [user] = useRecoilState(userState)
  const [orderType, setOrderType] = useState(null)
  const [orderSoQueue, setOrderSoQueue] = useState({})
  const [soNumber, setSoNumber] = useState(null)
  const [delvDate, setDelvDate] = useState(null)
  // const [orderData, setOrderData] = useState({})

  const getOrderData = () => {
    setIsLoading(true)
    fetch({
      url: `/order/${orderId}`,
    }).then((res) => {
      // console.log(res)
      if (res.data?.success) {
        // setOrderData(res.data?.data)
        setOrderSoQueue(res.data?.data?.orderSoQueue)
        setOrderType(res.data?.data?.orderType)
        setOrderHeaderData(res.data?.data?.orderHeader)
        setSoSapList(res.data?.data?.soSap)
        setTotalPrice(res.data?.data?.orderHeader?.totalPrice)
        setDiscountPrice(res.data?.data?.orderHeader?.discount)
        setDiscountType(res.data?.data?.orderHeader?.discountType)
        setRounding(res.data?.data?.orderHeader?.rounding)
        setNetPrice(res.data?.data?.orderHeader?.netPrice)
        if (res.data?.data?.soSap?.length > 0) setSoNumber(res.data?.data?.soSap[0].soNo)
        if (res.data?.data?.orderSoQueue) setDelvDate(res.data?.data?.orderSoQueue?.delvDate)
        if (res.data?.data?.orderHeader?.channel === '11') {
          setIsFixItemCat(true)
        } else {
          setIsFixItemCat(false)
        }
        // console.log('soTemp:', res.data?.data?.soTemp)
        // console.log('soSap:', res.data?.data?.soSap)
        if (res.data?.data?.soTemp?.length > 0) setHaveTemp(true)
      } else {
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const getOrderStatus = () => {
    fetch({
      url: `/order/${orderId}/status`,
    }).then((res) => {
      if (res?.data?.success) {
        if (!['DRF'].includes(res.data.data[res.data.data.length - 1].statusCode)) {
          setStatusOrder(res.data.data[res.data.data.length - 1].status)
          getOrderData()
        } else {
          return (
            history.push('/page-not-found')
          )
        }
      } else {
        console.log('Error:', res.data)
        message.error(res?.data?.message)
      }
    })
    setIsLoading(false)
  }

  const toggleCommentModal = () => {
    setCommentVisible(!commentVisible)
  }

  const onPut = (remark) => {
    setIsLoading(true)
    fetch({
      method: 'PUT',
      url: `/order/${orderId}/status`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        remark,
        action: title,
      },
    }).then((res) => {
      if (res?.data?.success) {
        message.success(res?.data?.message)
        setIsLoading(false)
        setCommentVisible(false)
        history.push('/review')
      } else {
        setIsLoading(false)
        message.error(res?.data?.message)
        setCommentVisible(false)
      }
    })
  }

  const onCommentSuccess = (remark) => {
    setCommentVisible(false)
    if (sumPayment < netPrice) {
      confirm({
        title: 'Confirmation',
        icon: <ExclamationCircleOutlined />,
        content: 'This order still have remaining balance. Do you want to continue Release PR ?',
        onOk() {
          onPut(remark)
        },
        onCancel() {

        },
      })
    } else {
      onPut(remark)
    }
  }

  useEffect(() => {
    getOrderStatus()
  }, [orderId])

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={(['ODS', 'ODV'].includes(statusOrder.statusCode)) ? `Review Order: ${orderId} ` : `Order: ${orderId} `}
          subTitle={statusOrder && <OrderStatus click={false} orderStatus={statusOrder?.statusCode} orderStatusDesc={statusOrder?.statusDescr} />}
        />
        <Row gutter={[8, 32]}>
          <Col span={24}>
            <OrderHeader orderId={orderId} sap={orderHeaderData} created submitted orderType={orderType} onSetIsFixItemCat={setIsFixItemCat} />
          </Col>
          {
            soSapList?.length > 0 && (
              <>
                <Col span={24}>
                  <SapSoComponent orderId={orderId} sap={soSapList} created submitted orderSoQueue={orderSoQueue} isFixItemCat={isFixItemCat} />
                </Col>
                <Col span={24}>
                  <Row style={{ float: 'right' }}>
                    <DiscountTotalSoPrice orderId={orderId} orderType={orderType} created soNumber={soNumber} />
                  </Row>
                </Col>
              </>
            )
          }
          {
            haveTemp && (
              <Col span={24}>
                <TempSoComponent orderId={orderId} orderType={orderType} />
              </Col>
            )
          }
        </Row>
        <div style={{ paddingTop: '2em' }}>
          <div>
            {
              user.role.length > 0 && orderType !== 'DSB'
              && (user.role.includes('ADMIN') || (user.role.includes('MERCH') && ['ODV'].includes(statusOrder.statusCode)) || (user.role.includes('REVIEWER') && ['ODS'].includes(statusOrder.statusCode)))
              && (
              <Space style={{ float: 'right' }}>
                <Button onClick={() => {
                  setTitle('Revise')
                  toggleCommentModal()
                }}
                >Revise
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    setTitle('Approve')
                    toggleCommentModal()
                  }}
                >Approve
                </Button>
              </Space>
              )
            }

            {/* {
              (user.role.length > 0 && (user.role.includes('REVIEWER') || user.role.includes('MERCH') || user.role.includes('ADMIN')) && orderType !== 'DSB' && ['ODS', 'ODV'].includes(statusOrder.statusCode)) && (
                <Space style={{ float: 'right' }}>
                  <Button onClick={() => {
                    setTitle('Revise')
                    toggleCommentModal()
                  }}
                  >Revise
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      setTitle('Approve')
                      toggleCommentModal()
                    }}
                  >Approve
                  </Button>
                </Space>
              )
            } */}
          </div>
          <Button icon={<LeftOutlined />} style={{ float: 'left' }} onClick={() => history.push('/order')}>Back</Button>
        </div>
      </Spin>
      <CommentModal
        title={title}
        orderId={orderId}
        onCancel={() => { toggleCommentModal() }}
        onSuccess={onCommentSuccess}
        visible={commentVisible}
        delvDate={delvDate}
      />
    </>
  )
}

export default ReviewDetail
